import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20still%20life%20composition%20with%20designer%20sneakers%20silk%20scarves%20gold%20jewelry%20and%20vintage%20sunglasses%20arranged%20on%20textured%20linen%20fabric%2C%20soft%20diffused%20morning%20light%20casting%20gentle%20shadows%2C%20warm%20earthy%20camel%20and%20sand%20color%20palette%2C%20editorial%20lifestyle%20photography%2C%20elevated%20minimalist%20aesthetic%2C%20luxury%20fashion%20flat%20lay&width=1600&height=1000&seq=hero-bg-v2-main&orientation=landscape"
          alt="Mulebuy spreadsheet fashion collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-20">
          <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left pt-10 lg:pt-0">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden border-2 border-white/80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20white%20leather%20designer%20sneaker%20with%20gold%20eyelet%20detail%20on%20marble%20surface%2C%20luxury%20product%20detail%20shot%2C%20cream%20and%20gold%20tones%2C%20editorial%20lighting&width=100&height=100&seq=hero-avatar-v2-01&orientation=squarish"
                    alt="Shoes category"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden border-2 border-white/80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20beige%20cashmere%20scarf%20folded%20neatly%20on%20light%20oak%20surface%2C%20luxury%20textile%20texture%20visible%2C%20soft%20warm%20lighting%2C%20minimalist%20detail%20shot&width=100&height=100&seq=hero-avatar-v2-02&orientation=squarish"
                    alt="Accessories category"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden border-2 border-white/80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20elegant%20watch%20with%20brown%20leather%20strap%20on%20cream%20linen%2C%20luxury%20timepiece%20detail%2C%20gold%20accents%2C%20warm%20ambient%20lighting%2C%20sophisticated%20product%20photography&width=100&height=100&seq=hero-avatar-v2-03&orientation=squarish"
                    alt="Bags category"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/90 text-xs md:text-sm font-medium whitespace-nowrap">
                Trusted by savvy buyers
              </span>
            </div>

            <h1 className="font-heading text-white">
              <span className="block text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
                Best Mulebuy
              </span>
              <span className="block text-3xl md:text-5xl lg:text-6xl font-light italic leading-tight mt-1">
                Spreadsheet Hub
              </span>
            </h1>

            <p className="text-white/80 text-sm md:text-base max-w-md mt-5 leading-relaxed">
              Find trusted mulebuy spreadsheet lists, compare verified agents, and access the most updated buying data — all in one place. Updated weekly with fresh sources.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm cursor-pointer hover:bg-white/90 transition-all whitespace-nowrap"
              >
                Access Latest Mulebuy Spreadsheet
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <Link
                to="/what-is-mulebuy-spreadsheet"
                className="px-6 py-3 rounded-full border border-white/60 text-white text-sm font-medium cursor-pointer hover:bg-white/10 transition-all whitespace-nowrap"
              >
                Learn More
              </Link>
            </div>

            <p className="text-white/50 text-xs mt-4 whitespace-nowrap">
              Updated weekly &bull; Verified sources &bull; Beginner friendly
            </p>
          </div>

          <div className="hidden lg:flex flex-1 items-center justify-center">
            <div className="relative">
              <div className="w-80 h-96 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20boutique%20window%20display%20with%20mannequin%20wearing%20beige%20trench%20coat%2C%20leather%20handbag%20on%20pedestal%2C%20and%20shoes%20arranged%20below%2C%20warm%20interior%20lighting%20spilling%20out%2C%20sophisticated%20retail%20display%20aesthetic%2C%20luxury%20shopping%20atmosphere%2C%20editorial%20commercial%20photography&width=800&height=1000&seq=hero-side-v2-01&orientation=portrait"
                  alt="Mulebuy spreadsheet fashion guide"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3 shadow-sm">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">500+ Spreadsheets</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">Verified & Updated</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <div className="flex flex-col items-center gap-2 text-white/50">
          <span className="text-xs">Scroll to explore</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}